import React from 'react';
import { Typography } from '@material-ui/core';
import moment from 'moment-timezone';

import { CALENDAR_VIEWS } from '../../../../resources/events/EventViewSettings';

export const getDays = (filterValues, timezone = moment.tz.guess()) => {
  if (!filterValues?.startTime) return {
    start: moment().tz(timezone).startOf('week').format('YYYY-MM-DD'),
    days: 7,
  }

  const start = moment.utc(filterValues.startTime);
  if (!filterValues.endTime) return {
    start: start.format('YYYY-MM-DD'),
    days: 1,
  }

  const end = moment.utc(filterValues.endTime);
  return {
    start: start.format('YYYY-MM-DD'),
    days: end.diff(start, 'days') + 1,
    type: CALENDAR_VIEWS.MONTH,
  }
}

export const buildWeekCalendarColumns = ({
  filterValues,
  timezone,
  getEventResource,
  getEventId,
  SNAP_MINUTES,
}) => {
  const { start, days } = getDays(filterValues);
  const startDate = moment(start);
  const values = days > 0 ? Array.from({ length: days }, (_, i) => moment(startDate).clone().add(i, 'days')) : [];
  const nextMonth = values.find(date => date.format('M') !== startDate.format('M'));
  const header = nextMonth ? `${startDate.format('MMMM')} - ${nextMonth.format('MMMM YYYY')}` : startDate.format('MMMM YYYY');
  const dates = values.map(date => date.format('YYYY-MM-DD'));

  return {
    header,
    disabled: false,
    alert: null,
    columns: values,
    totalColumns: values.length,
    dates,
    start,
    getColumnKey: date => date.toISOString(),
    getColumnIndex: event => {
      const { startTime, layout } = event;
      const date = moment.tz(layout?.startTime || startTime, timezone);
      return date.diff(startDate, 'days');
    },
    getColumnHeading: date => (
      <>
        <Typography variant="overline">{date.format('ddd')}</Typography>
        <Typography variant="h5">{date.format('D')}</Typography>
      </>
    ),
    filterEvents: events =>
      events.filter(event => event.date && event.startTime && event.endTime),
    pushSplitSurfaceEvents: events => events,
    toEventDetails: (item, eventResource, eventId) => {
      const { x: itemColumn, y: itemRow, h: itemHeight } = item;
      const resource = eventResource || getEventResource(item);
      const id = eventId || getEventId(item);

      const date = moment.tz(filterValues.startTime, timezone).add(itemColumn, 'days').format('YYYY-MM-DD');
      const startOfDay = { hours: 6, minutes: 0, seconds: 0 };
      const startTime = moment.tz(date, timezone).set(startOfDay).add(itemRow * SNAP_MINUTES, 'minutes').toISOString();
      const endTime = moment.tz(date, timezone).set(startOfDay).add((itemRow + itemHeight) * SNAP_MINUTES, 'minutes').toISOString();

      return { id, resource, date, startTime, endTime };
    },
  };
};
